import React from 'react';
import { Archive, BookOpenText, LayoutDashboard, Menu, MessageSquare, Plus, UserRound, Users } from 'lucide-react';
import { AppTab } from '../utils/routes';
import { useTranslation } from '../i18n/translations';
import { TeamMemberRole } from '../types';

interface MobileBottomNavProps {
  activeTab: AppTab;
  onNavigate: (tab: AppTab) => void;
  onMore: () => void;
  canCreateCampaign: boolean;
  workspaceRole?: TeamMemberRole;
}

export const MobileBottomNav: React.FC<MobileBottomNavProps> = ({ activeTab, onNavigate, onMore, canCreateCampaign, workspaceRole = 'client' }) => {
  const { tx } = useTranslation();
  const items: Array<{ tab: AppTab; label: string; icon: React.ElementType }> = workspaceRole === 'client'
    ? [
        { tab: 'dashboard', label: tx('الرئيسية'), icon: LayoutDashboard },
        { tab: 'saved', label: tx('الموافقات'), icon: Archive },
        { tab: 'team', label: tx('الفريق'), icon: Users },
        { tab: 'account', label: tx('الحساب'), icon: UserRound },
      ]
    : workspaceRole === 'copywriter'
      ? [
          { tab: 'dashboard', label: tx('الرئيسية'), icon: LayoutDashboard },
          { tab: 'saved', label: tx('المهام'), icon: Archive },
          { tab: 'library', label: tx('المحتوى'), icon: BookOpenText },
          { tab: 'team', label: tx('الفريق'), icon: Users },
        ]
      : [
          { tab: 'dashboard', label: tx('الرئيسية'), icon: LayoutDashboard },
          canCreateCampaign
            ? { tab: 'builder', label: tx('حملة جديدة'), icon: Plus }
            : { tab: 'team', label: tx('الفريق'), icon: Users },
          { tab: 'saved', label: tx('الحملات'), icon: Archive },
          { tab: 'chat', label: tx('المساعد'), icon: MessageSquare },
        ];

  return (
    <nav className="mobile-bottom-nav" aria-label={tx('التنقل السريع')}>
      {items.map(({ tab, label, icon: Icon }) => (
        <button
          key={tab}
          type="button"
          className={activeTab === tab ? 'is-active' : ''}
          aria-current={activeTab === tab ? 'page' : undefined}
          onClick={() => onNavigate(tab)}
        >
          <Icon />
          <span>{label}</span>
        </button>
      ))}
      <button type="button" onClick={onMore} className="mobile-bottom-more">
        <Menu />
        <span>{tx('المزيد')}</span>
      </button>
    </nav>
  );
};
